export default {
    data: {
        key: 'COMPANIES',
        name: 'Companies',
        maps: [
            { id: '1', alias: 'Mature', value: '1' },
            { id: '2', alias: 'Growing', value: '3' },
        ],
        values: [
            { id: '1', label: 'Small' },
            { id: '2', label: 'Mid-Market' },
            { id: '3', label: 'Growing' },
        ],
        entries: 7,
    },
}
